import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAppUrl } from '../../utils/useAppUrl';

const Link = ({
    to, children, onClick, ...props
}) => {
    const { withAppUrl } = useAppUrl();
    const history = useHistory();

    function handleClick(e) {
        onClick?.(e);
        e.preventDefault();
        history.push(to);
    }
    
    return (
        <a href={withAppUrl(to)} {...props} onClick={handleClick}>
            { children }
        </a>
    )
}



export default Link
